import { render } from "./Sertifikat.vue?vue&type=template&id=48cee800"
import script from "./Sertifikat.vue?vue&type=script&lang=js"
export * from "./Sertifikat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__